import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITab } from 'app/shared/model/ITab';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';

@Component({
    selector: 'grid-tab-navigation',
    template: `
        <div class="tabs">
            <div class="left-part">
                <tab-navigation [deactivationReason]="deactivationReason" [tabs]="tabs" display="columns" classList="tabs"></tab-navigation>
            </div>
            <div>
                <btn type="actionLink" classList="no-spacing" [label]="wording.close" (click)="onClose.emit()"></btn>
                <btn *ngIf="canValidate" class="validate-btn" type="actionDo" [label]="wording.validate" (click)="onValidate.emit()"></btn>
            </div>
        </div>
    `,
    styles: [`
        .tabs {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 .75rem;
            background-color: rgba(200, 200, 200, .2);
        }

        .validate-btn {
            margin-left: .75rem;
        }
    `]
})

export class GridTabNavigationComponent {
    @Input()
    public tabs: ITab[] = []; 

    @Input()
    public canValidate: boolean = false;

    @Input()
    public deactivationReason: string = null;

    @Output()
    public readonly onClose: EventEmitter<null> = new EventEmitter<null>();

    @Output()
    public readonly onValidate: EventEmitter<null> = new EventEmitter<null>();

    public readonly wording: ILabels = {
        validate: Yii.t('wui-quotation-js', 'Valider'),
        close: Yii.t('wui-quotation-js', 'Fermer')
    };
}